angular.module('createReferrals')
.controller('CreateReferralsController', ['$scope', '$state', '$stateParams', '$http', '$window', 'API_ENDPOINT', 'Notification', 'Auth', 'Referral', 'UnsavedChanges', 'Logger', 'ReferralHelper', 'ReferralAutosave', 'User', 'Practice', 'ModalHandler', '$uibModal',
    function ($scope, $state, $stateParams, $http, $window, API_ENDPOINT, Notification, Auth, Referral, UnsavedChanges, Logger, ReferralHelper, ReferralAutosave, User, Practice, ModalHandler, $uibModal) {

        // Reload persistence (DCL-440): the draft id is recorded under this key so a
        // reload can resume it. The resume itself happens in a $transitions.onBefore
        // hook (app.js) — before this controller or the template's child controllers
        // instantiate.
        var draftKey = 'dcl.createDraft.' + ($stateParams.pid || 'default');

        var auth = $scope.auth = Auth.get() || {};
        $scope.current_user = Auth.current_user;

        $scope.immediateUpdate = false;
        $scope.model = {referral: {notes_attributes: [], notes: []}, practice: {}};
        $scope.attachments = []; // uploads are immediate (DCL-369); completed ones land here
        $scope.autosaveState = 'idle';

        // Only fetch provider data if user is authenticated with valid practice_id and user id
        // This prevents unnecessary API calls when auth is stale or missing
        if (auth.practice_id) {
            // if there is only one provider in this practice, assign that user's ID here
            // if there are multiple providers and current user is a doctor, assign current user ID here
            // otherwise don't assign anything (leave empty)
            User.getProviders({practice_id: auth.practice_id}, function(allProviders) {
                if (allProviders.length == 1) {
                    $scope.model.referral.orig_provider_id = allProviders[0].id;
                } else if (allProviders.length > 1) {
                    let providerIds = allProviders.map(function(p) {return p.id});
                    if (providerIds.includes(auth.id)) {
                        $scope.model.referral.orig_provider_id = auth.id;
                    }
                }
            });
        }

        // populating addresses - only if user id is available
        if (auth.id) {
            User.get({id: auth.id}, function(user) {
                $scope.providerLocations = user.addresses;
                if (user.addresses.length < 2) {
                    $scope.disableLocations = true;
                    $scope.model.referral.orig_provider_address_id = user.addresses[0].id;
                }
            }, function(error) {
                // Silently handle authentication errors as authInterceptor will handle the redirect
                if (error.status !== 401 && error.status !== 403) {
                    Logger.log('Failed to load provider locations', error);
                }
            });
        }

        ReferralHelper.watchProviders($scope);

        if(typeof $stateParams.pid !== 'undefined') {
            Practice.getByPublicId({publicId: $stateParams.pid}, function(practice) {
                $scope.onPracticeSelected(practice);
            }, function (failure) {
                Notification.error(failure.data.message);
            });
        }

        // ---- live-draft autosave (DCL-369) ----
        // The draft row is created lazily on the first user edit (or first
        // attachment add); from then on every change autosaves, and Send only
        // finalizes the already-persisted draft.
        var autosave = ReferralAutosave.createSession({
            buildPayload: function () { return ReferralHelper.buildDraftPayload($scope); },
            createDraft: function (payload) { return Referral.save(payload).$promise; },
            // Publish the draft id onto the scope the instant the row is created,
            // regardless of which path triggered creation (a form edit's autosave
            // PUT or an attachment/CBCT upload's ensureDraftNow). DCL-214 CBCT
            // polling reads $scope.model.referral.id via cbctReferralId(); relying
            // only on onState (which fires from the autosave PUT flow) left the id
            // unset when a fast CBCT upload finalized before any PUT completed, so
            // startPollingIfNeeded bailed and the card was stuck "Processing…". The
            // guest controller already sets the id at creation time — mirror it.
            onDraftCreated: function (referralId) {
                $scope.model.referral.id = referralId;
                $window.sessionStorage.setItem(draftKey, referralId); // survive a reload (DCL-440)
            },
            onState: function (state) {
                $scope.autosaveState = state;
                // toast too: the button-block indicator may be scrolled off-screen (DCL-411)
                if (state === 'failed') {
                    Notification.error('Changes could not be saved. Please check your connection and try again.');
                }
                if (!$scope.model.referral.id) {
                    $scope.model.referral.id = autosave.referralId();
                }
            },
            onSaved: function (data, sentPayload) { ReferralHelper.syncSavedNotes($scope, data, sentPayload); }
        });
        ReferralHelper.wireAutosave($scope, autosave, function (scope) {
            return ReferralHelper.buildDraftPayload(scope);
        });

        // The notes block disables its new-note and edit controls while a
        // save request is open, so nothing races the list it answers with (DCL-636).
        $scope.notesBusy = function () { return autosave.isRequestInFlight(); };

        // First attachment add creates the draft; the upload awaits the id.
        // DCL-523: flush any pending autosave too. CBCT eligibility is decided
        // server-side from the draft's two practices, so starting an upload while
        // a just-picked Premium destination still sits in the 1s autosave debounce
        // would earn a 402 and a pointless upgrade modal.
        $scope.ensureDraftForUpload = function () {
            return autosave.ensureDraftNow().then(function (referralId) {
                return autosave.flush().then(function () { return referralId; });
            });
        };

        function doSendReferral() {
            autosave.flush().then(function () {
                var id = autosave.referralId();
                if (!id) {
                    Notification.error('Please fill in the referral before sending.');
                    return;
                }
                return $http.put(API_ENDPOINT + '/referrals/' + id + '/send', {}).then(function () {
                    $window.sessionStorage.removeItem(draftKey); // draft is sent (DCL-440)
                    UnsavedChanges.resetCbHaveUnsavedChanges(); // to make redirect
                    $state.go('viewReferral', {referral_id: id, isNew: true});
                });
            }).catch(function (failure) {
                var message = failure && failure.data && failure.data.message;
                Notification.error(message || 'An error occurred during referral creation...');
            });
        }

        // Helper function to show reverse referral warning modal
        function showReverseReferralWarning(existingReferral) {
            var modalInstance = $uibModal.open({
                templateUrl: 'partials/reverse_referral_warning_modal.html',
                controller: 'ReverseReferralWarningModalController',
                resolve: {
                    existingReferral: function () {
                        return existingReferral;
                    }
                }
            });

            ModalHandler.set(modalInstance);

            modalInstance.result.then(function (choice) {
                if (choice === 'view_existing') {
                    UnsavedChanges.resetCbHaveUnsavedChanges(); // to make redirect
                    $state.go('viewReferral', {referral_id: existingReferral.id});
                } else if (choice === 'create_new') {
                    doSendReferral();
                }
            }).catch(function () {
                // Modal was dismissed (cancelled), do nothing
            });
        }

        $scope.sendReferral = function () {
            $scope.form.$setDirty();
            $scope.sendAttempted = true;

            if ($scope.form.$invalid) {
                return false;
            }
            if ($scope.uploader && ($scope.uploader.isUploading || $scope.uploader.queue.length > 0)) {
                Notification.error('Please wait for attachments to finish uploading.');
                return false;
            }

            // Check for reverse referral (potential post-op being created as new referral)
            if ($scope.patient && $scope.patient.first_name && $scope.patient.last_name && $scope.patient.birthday && $scope.destinationPractice) {
                // DCL-431: no orig_practice_id — the backend takes the sending
                // practice from the session, so a stale auth_context cookie can
                // no longer decide (or break) this check.
                Referral.checkReverseReferral({
                    patient_first_name: $scope.patient.first_name,
                    patient_last_name: $scope.patient.last_name,
                    patient_birthday: moment($scope.patient.birthday).format('YYYY-MM-DD'),
                    dest_practice_id: $scope.destinationPractice.id
                }, function (result) {
                    if (result.reverse_referral) {
                        // Found a reverse referral, show warning modal
                        showReverseReferralWarning(result.reverse_referral);
                    } else {
                        // No reverse referral found, proceed normally
                        doSendReferral();
                    }
                }, function (error) {
                    // Error checking for reverse referral, proceed anyway
                    Logger.log('Failed to check for reverse referral', error);
                    doSendReferral();
                });
            } else {
                // Not enough info to check, proceed normally
                doSendReferral();
            }
        };

        $scope.discardTemplate = function (referral) {
            Referral.remove({id: referral.id},
                function (success) {
                    UnsavedChanges.resetCbHaveUnsavedChanges();
                    $state.go('history');
                }, function (failure) {
                    Notification.error('An error occurred during draft removal. Please try again later.');
                });
        };
    }]);
